import Url from '@mc/mc-utils/js/url/url'
import { platform } from '@/defines/environment'
import { getBaseInfo } from './get_base_info'

const getCompanyTokenFromUrl = () => {
  const url = new Url(window.location.href)
  const { companyToken = '' } = url.parseQuerystring()
  return companyToken
}

export const getCompanyToken = userInfo => {
  const appBaseInfo = getBaseInfo()
  if (platform === 'ios' || platform === 'android') {
    return (
      decodeURIComponent(
        userInfo.companyToken || appBaseInfo?.userInfo?.companyToken || ''
      ) || getCompanyTokenFromUrl()
    )
  }

  return getCompanyTokenFromUrl()
}
